import { createStore, applyMiddleware, compose } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";

import rootReducer from "./reducers";

export default () => {
	let store = createStore(
		rootReducer,
		{},
		compose(applyMiddleware(thunk), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f)
	);

	let persistor = persistStore(store);

	return {
		store,
		persistor,
	};
};
